import * as React from 'react';

export class TrashIcon extends React.PureComponent<{}, {}> {
  public render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
        <g fill="#8C8C8C" fillRule="nonzero">
          <path
            //tslint:disable-next-line:max-line-length
            d="M1.5 4.5v6c0 .825.675 1.5 1.5 1.5h6c.825 0 1.5-.675 1.5-1.5v-6h-9zM9 2.25V.75C9 .3 8.7 0 8.25 0h-4.5C3.3 0 3 .3 3 .75v1.5H0v1.5h12v-1.5H9zm-1.5 0h-3V1.5h3v.75z"
          />
        </g>
      </svg>
    );
  }
}
